import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'retailers-opt_in_nudges_view-view';

/**
 * Track successful view of the opt-in nudge surfaces. The "Origin" parameter below will return either "POPUP_PROMPT", "POST_ORDER_PRIMARY", "POST_ORDER_SECONDARY", or "FOOTER_PAGE"
 */
export function trackRetailersOptInNudgesViewView(
  Origin_string: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { Origin_string },
  });
}
